// ─── Smart paste sanitiser ────────────────────────────────────────────────────
const sanitizePastedHTML = (html) => {
    if (!html) return '';
    try {
        const parser = new DOMParser();
        const doc = parser.parseFromString(html, 'text/html');

        const allowedTags = new Set([
            'img', 'a', 'h1', 'h2', 'h3', 'h4', 'h5', 'h6', 'p', 'ul', 'ol', 'li',
            'strong', 'em', 'u', 'table', 'tr', 'td', 'th', 'tbody', 'thead', 'br'
        ]);

        const sanitizeNode = (node) => {
            if (node.nodeType === Node.TEXT_NODE) return;
            if (node.nodeType === Node.ELEMENT_NODE) {
                const tagName = node.tagName.toLowerCase();
                if (!allowedTags.has(tagName)) {
                    const parent = node.parentNode;
                    if (parent) {
                        while (node.firstChild) parent.insertBefore(node.firstChild, node);
                        parent.removeChild(node);
                    }
                    return;
                }
                const attrs = Array.from(node.attributes);
                for (const attr of attrs) {
                    const name = attr.name.toLowerCase();
                    if (tagName === 'img') {
                        if (!['src', 'alt', 'class', 'style', 'data-width-percent', 'data-align'].includes(name)) node.removeAttribute(name);
                    } else if (tagName === 'a') {
                        if (!['href', 'target', 'rel', 'class'].includes(name)) node.removeAttribute(name);
                    } else {
                        if (!['class', 'style'].includes(name)) node.removeAttribute(name);
                    }
                }
                Array.from(node.childNodes).forEach(sanitizeNode);
            }
        };

        const body = doc.body;
        Array.from(body.childNodes).forEach(sanitizeNode);
        return body.innerHTML;
    } catch (e) {
        console.error('Error sanitizing pasted HTML:', e);
        return html;
    }
};

export default sanitizePastedHTML;
